module.exports = __webpack_public_path__ + "assets/img/e99c-bd.svg";